import React from "react";
import FilterToggle from "../../atoms/FilterToggle";

const GlobalSearch = ({ filters, setFilters }) => {
    const handleChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    return (
        <FilterToggle>
            <div className="flex gap-4 mb-4">
                <input
                    type="text"
                    placeholder="Buscar por nombre"
                    name="user"
                    value={filters.user}
                    onChange={handleChange}
                    className="border p-2 rounded w-full md:w-1/3"
                />
                <input
                    type="text"
                    placeholder="Buscar por email"
                    name="email"
                    value={filters.email}
                    onChange={handleChange}
                    className="border p-2 rounded w-full md:w-1/3"
                    />
            </div>
        </FilterToggle>
    );
};

export default GlobalSearch;